import React from 'react'
import { permissions } from '../../../../utility/utils'
import toast from 'react-hot-toast'
import { Alert, Button, Col, Container, Row } from 'reactstrap'

const CheckPermission = ({ hasCameraPermission, setHasCameraPermission }) => {
  const [isBlockedByBrowser, setIsBlockedByBrowser] = React.useState(false)
  // const [hasCameraPermission, setHasCameraPermission] = React.useState(false)
  const [countClick, setCountClick] = React.useState(0)
  const [pending, setPending] = React.useState(false)

  const checkPermissions = async () => {
    try {
      const permission = await navigator.permissions.query({ name: 'camera' })
      // console.log(permission);
      setHasCameraPermission(permission.state === 'granted')
      return permission.state === 'granted'
    } catch (error) {
      setHasCameraPermission(false)
      return false
    }
  }

  const randomPermission = () => {
    const randomIndex = Math.floor(Math.random() * permissions.length)
    console.log(permissions[randomIndex])
    return permissions[randomIndex]
  }

  const requestCameraPermission = async () => {
    // validar permisos de cámara
    const constraints = {
      video: true,
      [randomPermission()]: false
    }
    setPending(true)
    await navigator.mediaDevices
      .getUserMedia(constraints)
      .then(function (stream) {
        // const video = document.querySelector('video')
        // video.srcObject = stream
        // video.onloadedmetadata = function (e) {
        //   video.play()
        // }
      })
      .catch(function (err) {
        if (countClick >= 2) {
          setIsBlockedByBrowser(true)
        } else setIsBlockedByBrowser(false)
        setCountClick(countClick + 1)
        console.log(`${err?.code} ${err.name}: ${err.message}`)
      })
      .finally(() => {
        checkPermissions()
        setPending(false)
      })
  }

  const promisifiedOldGUM = function (
    constraints,
    successCallback,
    errorCallback
  ) {
    // First get ahold of getUserMedia, if present
    const getUserMedia =
      navigator.getUserMedia ||
      navigator.webkitGetUserMedia ||
      navigator.mozGetUserMedia

    // Some browsers just don't implement it - return a rejected promise with an error
    // to keep a consistent interface
    if (!getUserMedia) {
      return Promise.reject(
        new Error('No existe el método getUserMedia en el navegador')
      )
    }

    // Otherwise, wrap the call to the old navigator.getUserMedia with a Promise
    return new Promise(function (successCallback, errorCallback) {
      getUserMedia.call(navigator, constraints, successCallback, errorCallback)
    })
  }

  React.useEffect(() => {
    if (navigator.mediaDevices === undefined) {
      toast.error('La versión de tu navegador no es compatible con la cámara')
      navigator.mediaDevices = {}
    }

    if (navigator.mediaDevices.getUserMedia === undefined) {
      toast.error('La versión de tu navegador no es compatible con la cámara')
      navigator.mediaDevices.getUserMedia = promisifiedOldGUM
    }
    // requestCameraPermission()
  }, [])

  return (
    <Row className='col-lg-8 col-md-12 col-sm-12 py-4 m-auto' style={{
      minHeight: '83vh'
      }}>
      <Col md='3'></Col>
      <Col md="6">
        {(!hasCameraPermission && !isBlockedByBrowser) && (
          <>
            <h1 className="display-4">¡Permiso de cámara requerido!</h1>
            <p className="lead">
              Para verificar tu identificación, necesitamos acceso a la cámara.
            </p>
            <Button
              color="primary"
              onClick={requestCameraPermission}
              disabled={pending}
              block
            >
              Solicitar permisos
            </Button>
          </>
        )}
        {isBlockedByBrowser && (
          <Alert color="danger">
            <h4 className="alert-heading">¡Ups! Parece que tu navegador no permite el acceso a la cámara</h4>
            <p className='p-2'>
              Por favor, intenta con otro navegador o revisa la configuración de
              tu navegador.
            </p>
          </Alert>
        )}
      </Col>
      <Col md='3'></Col>
    </Row>
  )
}

export default CheckPermission
